import { Link } from 'react-router'
import type { ReactNode } from 'react'
import type { BadgeColor } from './StatusBadge'

const colorClasses: Record<BadgeColor, string> = {
  primary: 'bg-primary-50 text-link',
  success: 'bg-success-50 text-positive',
  danger: 'bg-danger-50 text-negative',
  warning: 'bg-warning-50 text-notice',
  info: 'bg-info-50 text-informative',
  secondary: 'bg-surface text-muted',
}

interface KpiCardProps {
  label: string
  value: number | string | undefined
  /** ReactNode (icona lucide-react) per le pagine già migrate; stringa 'bi-*' accettata per compatibilità nelle pagine non ancora migrate a Tailwind. */
  icon: ReactNode | string
  color: BadgeColor
  to?: string
}

/** Card KPI per pagine interne (Properties, Customers, ecc.). */
export function KpiCard({ label, value, icon, color, to }: KpiCardProps) {
  const card = (
    <div className="flex h-full items-center justify-between rounded-xl border border-border bg-canvas p-4 shadow-sm transition-shadow hover:shadow-md">
      <div>
        <p className="m-0 mb-1 text-muted">{label}</p>
        <h3 className="m-0 text-2xl font-semibold">{value ?? '-'}</h3>
      </div>
      <span className={`flex h-12 w-12 items-center justify-center rounded-xl ${colorClasses[color]}`}>
        {typeof icon === 'string' ? <i className={`bi ${icon} text-xl`}></i> : icon}
      </span>
    </div>
  )

  if (to) {
    return (
      <Link to={to} className="block no-underline">
        {card}
      </Link>
    )
  }

  return card
}
